module.exports = __webpack_public_path__ + "static/media/password_recovery.1a1e17c7.png";